export function prefetchScript(href, marker) {
  prefetch(href, marker, 'script')
}

function prefetch(href, marker, asType) {
  if (!globalThis.document || globalThis.document.querySelector(`link[href="${href}"]`)) {
    return
  }

  if (!href) {
    return
  }

  const link = globalThis.document.createElement('link')
  link.setAttribute('as', asType)
  link.setAttribute('href', href)
  link.setAttribute('rel', 'prefetch')
  if (marker) {
    link.dataset.marker = marker
  }

  globalThis.document.head.append(link)
  return link
}
